import httpClient from "@/core/axios";

export default {
    namespaced: true,
    state: {
        emails: []
    },
    getters: {
        emails(state) {
            return state.emails;
        },
        primary(state) {
            return state.emails.find(email => email.is_primary);
        }
    },
    actions: {
        async fetch(context) {
            return httpClient
                .get("/api/guest/app/:app_uuid/user/emails")
                .then(data => context.commit("SET_EMAILS", data));
        },
        async create(context, { address, is_primary }) {
            return httpClient
                .post("/api/guest/app/:app_uuid/user/emails", {
                    address,
                    is_primary
                })
                .then(data => context.commit("SET_EMAILS", data));
        },
        async update(context, { id, address, is_primary }) {
            return httpClient
                .patch(`/api/guest/app/:app_uuid/user/emails/${id}`, {
                    address,
                    is_primary
                })
                .then(data => context.commit("SET_EMAILS", data));
        },
        async delete(context, { id }) {
            return httpClient
                .delete(`/api/guest/app/:app_uuid/user/emails/${id}`)
                .then(data => context.commit("SET_EMAILS", data));
        }
    },
    mutations: {
        SET_EMAILS(state, data) {
            state.emails = data;
        }
    }
};
